import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService } from "shared-components";
import { EtiquetadoService } from "../../../services/etiquetado.service";

@Component({
    selector: 'app-etq-denominaciones',
    templateUrl: './denominaciones.component.html'
})
export class DenominacionesEtiquetadorComponent implements OnInit {

    public new = false;
    public denominacionEditable;
    public denominacionesList;

    public allGrupoEtiquetasCaja = null;
    public allGrupoEtiquetasPallet = null;

    public toCloseSpinner = 0;

    @Input() etiquetadorId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {

        if (this.role === "Administrador") {
            const promises: Promise<any>[] = [];
            promises.push(this.getAllGruposEtiquetaCajas());
            promises.push(this.getAllGruposEtiquetaPallet());
            Promise.all(promises).then(
                () => {
                    this.getDenominacionesEtiquetador();
                    return true;
                }, (error) => {
                    if (error.status === 420) {
                        this.pushMessage.emit('global.error.noAccess');
                    } else {
                        this.pushMessage.emit('global.error.noResponse');
                    }
                }
            ).catch(e => console.log(e));
        } else {
            this.getDenominacionesEtiquetador();
        }

    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getDenominacionesEtiquetador() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.getDenominacionesEtiquetador(this.etiquetadorId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.denominacionesList = resp;
        });
    }

    public getAllGruposEtiquetaCajas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 1
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasCaja = resp.lista;
                    this.allGrupoEtiquetasCaja.unshift({ id: 0, des: this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas') });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getAllGruposEtiquetaPallet(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 2
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasPallet = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasPallet.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getGruposEtiqueta(denominacion, number) {
        return denominacion.gruposEtiquetaEtiquetadorPaisDenominacion.filter(x => x.tipoConfeccionId === number);
    }

    public newPaisDenominacion() {
        this.new = true;
        this.denominacionEditable = '';
    }

    public editableChanged(denominacion) {
        this.denominacionEditable = denominacion;
        this.new = false;
    }

    public toRefresh(value) {
        this.getDenominacionesEtiquetador();
        this.refresh.emit(value);
        this.denominacionEditable = '';
        this.new = false;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}
